import { useState } from "react";
import ReactTable from "../General/ReactTable";

function SearchOtherHeadLedger({ SelectLedger, Close, LoadLedger }) {
  const [Selected, setSelected] = useState(false);
  const columns = [
    {
      Header: "SNO",
      accessor: "sNo",
      maxWidth: 70,
    },
    {
      Header: "Code",
      accessor: "ledCode",
      maxWidth: 100,
    },
    {
      Header: "Name",
      accessor: "ledName",
      id: "ledId",
    },
    {
      Header: "GroupName",
      accessor: "tGrpName",
    },
  ];
  return (
    <div className="UOMMaster">
      <div className="UOMMaster-Box">
        <div className="UOMMaster-Container mt-1">
          <div className="Ledger">
            <div className="row">
              <ReactTable
                columns={columns}
                data={LoadLedger}
                minRows={5}
                row_click={(Ledger, Index) => {}}
                row_doubleclick={(Ledger, Index) => {
                  SelectLedger(Ledger);
                }}
                background={true}
                className="full-table"
              />
            </div>
          </div>
        </div>
        <span className="close-icon" onClick={Close}>
          x
        </span>
      </div>
    </div>
  );
}
export default SearchOtherHeadLedger;
